var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCsvicon = function SvgCsvicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.696 1.6h12.8a1.6 1.6 0 0 1 1.6 1.6v9.6a1.6 1.6 0 0 1-1.6 1.6h-12.8a1.6 1.6 0 0 1-1.6-1.6V3.2a1.6 1.6 0 0 1 1.6-1.6Zm9.6 1.6v2.4h3.2V3.2h-3.2Zm-5 2.4V3.2h3.6v2.4h-3.6Zm-4.6-2.4v2.4h3.2V3.2h-3.2Zm9.6 5.8V7h3.2v2h-3.2Zm-5-2v2h3.6V7h-3.6Zm-4.6 2V7h3.2v2h-3.2Zm9.6 1.4v2.4h3.2v-2.4h-3.2Zm-5 2.4v-2.4h3.6v2.4h-3.6Zm-4.6-2.4v2.4h3.2v-2.4h-3.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgCsvicon;